import { useCallback, useRef } from 'react';

export default <T extends () => void>() => {
  const ref = useRef<T>();

  const callAndDispose = useCallback(() => {
    if (ref.current) {
      ref.current();
      ref.current = undefined;
    }
  }, []);

  return [ref, callAndDispose] as const;
};
